import { Link, NavLink, useNavigate } from "react-router";
import { Stack, Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { HugeiconsIcon } from "@hugeicons/react";
import { NoInternetIcon } from "@hugeicons/core-free-icons";

import { useScreenSize } from "../../utils/hooks/useScreenSize ";

export const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile, isTablet } = useScreenSize();

  const smallScreen = isMobile || isTablet;

  const handleGoBack = () => {
    // Check if there's a previous page in history
    if (window.history.length > 1) {
      const currentUrl = window.location.pathname;
      const referrer = document.referrer;

      // If the referrer URL is the same as current URL or empty, go to /app
      if (!referrer || referrer.includes(currentUrl)) {
        navigate("/app");
      } else {
        // Go back to previous page
        window.history.back();
      }
    } else {
      // No history, go to /app
      navigate("/app");
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Row className="w-100">
        <Col className="text-center">
          <div className="mb-4">
            {/* Large 404 number with gradient */}
            <h1
              className={`${
                smallScreen ? "display-3" : "display-1"
              } fw-bold text-brand mb-3`}
            >
              404
            </h1>

            {/* Error icon */}
            <div className="mb-4">
              <HugeiconsIcon
                size={smallScreen ? 80 : 120}
                icon={NoInternetIcon}
              />
            </div>
          </div>

          {/* Error message */}
          <h2 className={`${smallScreen ? "h5" : "h3"} mb-3 text-dark`}>
            {t("PAGE_NOT_FOUND")}
          </h2>

          <p
            className={`${
              smallScreen ? "mb-3 px-2" : "lead text-muted mb-4 px-3"
            }`}
          >
            {t("PAGE_NOT_FOUND_DESCRIPTION")}
          </p>

          {/* Action buttons */}
          <Stack
            gap={smallScreen ? 2 : 3}
            className="d-flex flex-column align-items-center justify-content-center"
          >
            <button
              className={`btn btn-primary ${
                smallScreen ? "btn-md px-3 py-2" : "btn-lg px-4 py-2"
              } rounded-pill shadow-sm`}
              onClick={handleGoBack}
            >
              {t("GO_BACK_TO_PLATFORMS")}
            </button>
          </Stack>

          {/* Additional help text */}
          <div
            className={`${smallScreen ? "mt-3 pt-3" : "mt-5 pt-4"} border-top`}
          >
            <p className="small text-muted mb-0">
              {t("NEED_HELP")}
              <Link to="/app/support" className="text-decoration-none ms-1">
                {t("CONTACT_SUPPORT")}
              </Link>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
